import { NgModule } from "@angular/core";
import { BaseFilterComponent } from "./base-filter/base-filter.component";
import { CurrencyFilterComponent } from "../currency-filter/currency-filter.component";
import { CoreModule } from "../../../core/core.module";
import { EmptyComponent } from "../empty/empty.component";
import { NoResultsFoundComponent } from "../no-results-found/no-results-found.component";

const components = [BaseFilterComponent, CurrencyFilterComponent, NoResultsFoundComponent, EmptyComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class FilterModule {}
